import {
  CATALOG_CATEGORY_OPTIONS,
  CATALOG_SPECIMEN_OPTIONS,
  SPECIMEN_HELPER,
} from '@/modules/lab/catalog/catalogConstants'
import type { SelectorGroup, SelectorOption } from '@/modules/lab/catalog/components/selectorTypes'
import { getOperatorPrefs } from '@/modules/lab/catalog/catalogOperatorPrefs'

function withRecent(
  all: readonly SelectorOption[],
  recentValues: string[],
  allLabel: string,
): SelectorGroup[] {
  const recent = recentValues
    .map((v) => all.find((o) => o.value === v))
    .filter(Boolean) as SelectorOption[]
  const recentSet = new Set(recent.map((o) => o.value))
  const rest = all.filter((o) => !recentSet.has(o.value))
  const groups: SelectorGroup[] = []
  if (recent.length > 0) {
    groups.push({ label: 'Recently used', options: recent })
  }
  groups.push({ label: allLabel, options: [...rest] })
  return groups
}

export function buildCategorySelectorGroups(): SelectorGroup[] {
  const prefs = getOperatorPrefs()
  const all: SelectorOption[] = CATALOG_CATEGORY_OPTIONS.map((o) => ({
    value: o.value,
    label: o.label,
  }))
  return withRecent(all, prefs.recentCategories, 'All departments')
}

export function buildSpecimenSelectorGroups(): SelectorGroup[] {
  const prefs = getOperatorPrefs()
  const all: SelectorOption[] = CATALOG_SPECIMEN_OPTIONS.map((o) => ({
    value: o.value,
    label: o.label,
    description: SPECIMEN_HELPER[o.value],
  }))
  return withRecent(all, prefs.recentSpecimens, 'All specimen types')
}
